module.exports = __webpack_public_path__ + "img/办公设备.ae263306.gif";